"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserWarning = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var _isOldEdge;
function isOldEdge() {
    if (_isOldEdge != null)
        return _isOldEdge;
    var ua = navigator.userAgent.toString();
    var result = ua.match(/Edge\/\d+\.(\d+)/);
    if (result && Number(result[1]) < 17763)
        return (_isOldEdge = true);
    return (_isOldEdge = false);
}
var BrowserWarning = function () {
    return isOldEdge() ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Message, { negative: true, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Message.Header, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "warning sign" }), i18n_1.default.isUnsupportedBrowserMessageTitle] }), (0, jsx_runtime_1.jsx)("p", { children: i18n_1.default.isOldEdgeMessageContent })] }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.BrowserWarning = BrowserWarning;
